exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-card[data-v-25b20580]{box-shadow:0 .25rem .5rem rgba(0,0,0,.15);margin:5px 15px;padding:2.5em;height:100%}.card-image-container[data-v-25b20580]{margin-top:25px}.card-person-info[data-v-25b20580],.card-person-link[data-v-25b20580]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25b20580","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CarouselComponent.vue
// module id = 68
// module chunks = 0